import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CommunityCounter = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/community/stats`).then(r => setStats(r.data)).catch(() => {});
  }, []);

  const sections = [
    { key: 'genz', label: 'Agora GenZ', icon: '\u2694', color: '#FFD700', count: stats?.genz || 0 },
    { key: 'boomer', label: 'Boomer & GenX', icon: '\u2615', color: '#CD7F32', count: stats?.boomer || 0 },
    { key: 'senatori', label: 'I Senatori', icon: '\u265F', color: '#C0C0C0', count: stats?.senatori || 0 },
    { key: 'inclusivo', label: 'Spazio Inclusivo', icon: '\u2764', color: '#E040FB', count: stats?.inclusivo || 0 },
    { key: 'sport', label: 'Sport per Tutti', icon: '\u26BD', color: '#FF6B35', count: stats?.sport || 0 },
  ];

  const total = sections.reduce((s, x) => s + x.count, 0);

  return (
    <section data-testid="community-counter" className="py-16 relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src="/valdelsa_torri_colori.png" alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-[#050505]/80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4">
        <div className="text-center mb-8">
          <p className="text-[#00FF41] font-mono text-xs uppercase tracking-[0.3em] mb-2">
            Il Covo cresce — in tempo reale
          </p>
          <div className="flex items-baseline justify-center gap-3 mb-2">
            <span className="text-5xl md:text-6xl font-black font-mono text-white" style={{ textShadow: '0 0 30px rgba(255,255,255,0.15)' }}>
              {total}
            </span>
            <span className="text-white font-mono font-bold text-lg">anime al Covo</span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {sections.map(s => (
            <div key={s.key} className="bg-black/40 backdrop-blur-sm border rounded-xl p-4 text-center transition-all hover:scale-105"
              style={{ borderColor: `${s.color}30` }}
              data-testid={`counter-${s.key}`}
            >
              <span className="text-2xl block mb-1">{s.icon}</span>
              <span className="text-2xl font-black font-mono block" style={{ color: s.color }}>{s.count}</span>
              <span className="text-white font-mono font-bold text-[10px] uppercase tracking-wider">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityCounter;
